// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UG8y","label":"styles_label__38y8U"};